import Vue from 'vue'

Vue.directive('draggable', {
  bind: (el: any, binding) => {
    const { value } = binding
    const { meta, canDrag } = value
    if (!canDrag) return
    el.__bindFuction__ = function (e) {
      e.dataTransfer.setData('Text', JSON.stringify(meta))
    }

    el.setAttribute('draggable', true)
    el.addEventListener('dragstart', el.__bindFuction__)
  },
  unbind: (el: any) => {
    el.removeEventListener('dragstart', el.__bindFuction__)
  }
})

Vue.directive('dropbale', {
  bind: (el, binding) => {
    const { value } = binding

    el.__canDrop__ = function (e) {
      e.preventDefault();
    }

    el.__dropFunction__ = function (e) {
      const str = e.dataTransfer.getData('Text') || null
      console.log(0)
      value(JSON.parse(str))
    }
    el.addEventListener('drop', el.__dropFunction__)
    el.addEventListener('dragover', el.__canDrop__)
  },
  unbind: (el: any) => {
    el.removeEventListener('drop', el.__dropFunction__)
    el.removeEventListener('dragover', el.__canDrop__)
  }
})
